const data = [
    {
        stack: "MERN", 
        title: "Tourist Hub", 
        image: "https://i.ibb.co/TL6Vc2w/tourist-hub.png",
        description: "A tour operator website. Customers can book packages, review services and keep track of bookings. Admin can manage bookings, customers, users, packages from dashboard.", 
        code: "https://github.com/dahabib/tourist-hub", 
        demo: "https://tourist-hub-bd.web.app",
    }, 
    {
        stack: "MERN, e-Commerce", 
        title: "SBL Shop", 
        image: "https://i.ibb.co/WDy5wm4/sbl-shop.png",
        description: "An e-Commerce website. Customers can place order, keep track of order. Admin can manage orders, users and inventory", 
        code: "https://github.com/dahabib/sbl-shop", 
        demo: "https://sbl-shop.firebaseapp.com",
    }, 
    {
        stack: "React", 
        title: "Moons cuisine", 
        image: "https://i.ibb.co/KGykg6f/moons-cuisine.png",
        description: "Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.", 
        code: "https://github.com/dahabib/moons-cuisine", 
        demo: "https://dahabib.github.io/moons-cuisine/",
    }, 
    {
        stack: "Vanila Javascript", 
        title: "Fancy Slider", 
        image: "https://i.ibb.co/YXbnFqT/fancy-slider.png",
        description: "An application to serach photo and then make slider selecting from searched images.", 
        code: "https://github.com/dahabib/fancy-slider", 
        demo: "https://dahabib.github.io/fancy-slider/",
    }, 
]

export default data;